import React, {Component, Fragment} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle,
  Input
} from 'reactstrap';
import {Field, Form as FinalForm} from 'react-final-form';
import {withTranslation} from 'react-i18next';
import TextField from '../../../../components/TextField';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {NotificationManager} from '../../../../components/common/react-notifications';
import LoaderButton from '../../../../components/LoaderButton';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import FieldError from '../../../../components/FieldError';
import Api from '../../../../services/Api';
import Select from 'react-select';

class Update extends Component {
  constructor(props) {
    super(props);
    this.state = {
      admin: props.location.state.admin,
      rbac: null,
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/rbac');
      this.setState({
        rbac: data,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  updateAdmin = async values => {
    const {t} = this.props;
    const {admin} = this.state;
    try {
      await Api.invoke('PATCH', `/v2/admin-ui/adminUsers/${admin.username}`, {
        ...values,
        id: admin.id,
        role: values.role.value,
      });
      NotificationManager.success(t('Admin updated successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  ReactSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      placeholder={this.props.t('Select')}
    />
  );

  render() {
    const {t, match} = this.props;
    const {rbac, admin} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {t('Update Admin')}
                </CardTitle>
                <FinalForm
                  onSubmit={this.updateAdmin}
                  initialValues={{
                    role: {label: admin.role, value: admin.role},
                    firstName: admin.firstName,
                    lastName: admin.lastName,
                    phoneNumber: admin.phoneNumber,
                    email: admin.email,
                  }}
                  render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
                    return (
                      <Form onSubmit={handleSubmit}>
                        <Row className='mb-2'>
                          <Col className='col-lg-6 col-md-12'>
                            <Input type='text' disabled={true} value={admin.username}/>
                          </Col>
                        </Row>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                            <TextField
                              item={{
                                name: 'firstName',
                                i18n: t('First Name'),
                                type: 'text',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                            <TextField
                              item={{
                                name: 'lastName',
                                i18n: t('Last Name'),
                                type: 'text',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                            <TextField
                              item={{
                                name: 'phoneNumber',
                                i18n: t('Mobile Number'),
                                type: 'text',
                                required: true,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                            <TextField
                              item={{
                                name: 'email',
                                i18n: t('Email'),
                                type: 'text',
                                required: true,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col className='col-lg-6 col-md-12'>
                           <span>
                             {t('Role')}
                           </span>
                            <Field
                              name="role"
                              component={this.ReactSelectAdapter}
                              isLoading={!rbac || !rbac.roles}
                              options={rbac && rbac.roles ? rbac.roles.map(role => ({label: role, value: role})) : []}
                              closeMenuOnSelect={false}
                            />
                            <FieldError name='role' />
                          </Col>
                        </Row>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                            <TextField
                              item={{
                                name: 'password',
                                i18n: t('New Password'),
                                type: 'password',
                              }}
                            />
                          </Col>
                        </Row>
                        <LoaderButton
                          loading={submitting}
                          onClick={handleSubmit}
                          disabled={pristine || hasValidationErrors || submitting}
                          className="mt-4 text-center"
                          style={{minWidth: '100px'}}>
                          {t('Save')}
                        </LoaderButton>
                      </Form>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(Update);
